module.exports = __webpack_public_path__ + "img/admin_adv_20.555bb16c.png";